export default __webpack_public_path__ + "static/media/layout5.3f0d6771.svg";